import { render, staticRenderFns } from "./ContactMessage.vue?vue&type=template&id=12d2b3c2&scoped=true&"
import script from "./ContactMessage.vue?vue&type=script&lang=js&"
export * from "./ContactMessage.vue?vue&type=script&lang=js&"
import style0 from "./ContactMessage.vue?vue&type=style&index=0&id=12d2b3c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2b3c2",
  null
  
)

export default component.exports